const POPULAR_MAKES = [
  {
    id: 'a028d000000EKWiAAO',
    enName: 'Nissan',
    arName: 'نيسان',
    image: 'https://sylndr-website.s3.us-east-2.amazonaws.com/Car+Make+Logos/Nissan.jpg',
  },
  {
    id: 'a028d000000EKWoAAO',
    enName: 'Renault',
    arName: 'رينو',
    image: 'https://sylndr-website.s3.us-east-2.amazonaws.com/Car+Make+Logos/Renault.jpg',
  },
  {
    id: 'a028d000000EKWSAA4',
    enName: 'Hyundai',
    arName: 'هيونداى',
    image: 'https://sylndr-website.s3.us-east-2.amazonaws.com/Car+Make+Logos/Hyundai.jpg',
  },
  {
    id: 'a028d000000EKWYAA4',
    enName: 'Kia',
    arName: 'كيا',
    image: 'https://sylndr-website.s3.us-east-2.amazonaws.com/Car+Make+Logos/Kia.jpg',
  },
  {
    id: 'a028d000000EKW1AAO',
    enName: 'Toyota',
    arName: 'تويوتا',
    image: 'https://sylndr-website.s3.us-east-2.amazonaws.com/Car+Make+Logos/Toyota.jpg',
  },
  {
    id: 'a028d000000EKWjAAO',
    enName: 'Opel',
    arName: 'أوبل',
    image: 'https://sylndr-website.s3.us-east-2.amazonaws.com/Car+Make+Logos/Opel.jpg',
  },
  {
    id: 'a028d000000EKWlAAO',
    enName: 'Peugeot',
    arName: 'بيجو',
    image: 'https://sylndr-website.s3.us-east-2.amazonaws.com/Car+Make+Logos/Peugeot.jpg',
  },
  {
    id: 'a028d000000EKWMAA4',
    enName: 'Fiat',
    arName: 'فيات',
    image: 'https://sylndr-website.s3.us-east-2.amazonaws.com/Car+Make+Logos/Fiat.jpg',
  },
  {
    id: 'a028d000000EKWdAAO',
    enName: 'MG',
    arName: 'إم جي',
    image: 'https://sylndr-website.s3.us-east-2.amazonaws.com/Car+Make+Logos/MG.jpg',
  },
  {
    id: 'a028d000000EKW8AAO',
    enName: 'BMW',
    arName: 'بى ام دبليو',
    image: 'https://sylndr-website.s3.us-east-2.amazonaws.com/Car+Make+Logos/BMW.jpg',
  },
  {
    id: 'a028d000000EKWGAA4',
    enName: 'Chevrolet',
    arName: 'شيفروليه',
    image: 'https://sylndr-website.s3.us-east-2.amazonaws.com/Car+Make+Logos/Chevrolet.jpg',
  },
  {
    id: 'All Makes',
    enName: 'All Makes',
    arName: 'جميع الموديلات',
    image: '',
  },
];
export default POPULAR_MAKES;
